import {
  REQUEST_RETRANSLATIONS,
  RESPONSE_RETRANSLATIONS,
  REQUEST_RETRANSLATIONS_FAILURE,
  REQUEST_RETRANSLATIONS_TYPES,
  RESPONSE_RETRANSLATIONS_TYPES,
  REQUEST_RETRANSLATIONS_FAILURE_TYPES,
  REQUEST_CREATE_RETRANSLATION_UNIT,
  RESPONSE_CREATE_RETRANSLATION_UNIT,
  REQUEST_CREATE_RETRANSLATION_UNIT_FAILURE,
  REQUEST_DELETE_RETRANSLATION_UNIT,
  RESPONSE_DELETE_RETRANSLATION_UNIT,
  REQUEST_DELETE_RETRANSLATION_UNIT_FAILURE,
} from "../actions/retranslationsActions";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  retranslationsDataState: queriesStates.NOT_REQUESTED,
  retranslationsTypesDataState: queriesStates.NOT_REQUESTED,
  createRetranslationUnitTypesDataState: queriesStates.NOT_REQUESTED,
  deleteRetranslationUnitTypesDataState: queriesStates.NOT_REQUESTED,
  retranslations: [],
  retranslationsTypes: [],
  errors: [],
};

const retranslationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_RETRANSLATIONS: {
      return Object.assign({}, state, {
        retranslationsDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_RETRANSLATIONS: {
      return Object.assign({}, state, {
        retranslationsDataState: queriesStates.READY,
        retranslations: action.data.retranslationHosts,
      });
    }
    case REQUEST_RETRANSLATIONS_FAILURE: {
      return Object.assign({}, state, {
        retranslationsDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_RETRANSLATIONS_TYPES: {
      return Object.assign({}, state, {
        retranslationsTypesDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_RETRANSLATIONS_TYPES: {
      return Object.assign({}, state, {
        retranslationsTypesDataState: queriesStates.READY,
        retranslationsTypes: action.data,
      });
    }
    case REQUEST_RETRANSLATIONS_FAILURE_TYPES: {
      return Object.assign({}, state, {
        retranslationsTypesDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_CREATE_RETRANSLATION_UNIT: {
      return Object.assign({}, state, {
        createRetranslationUnitTypesDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_CREATE_RETRANSLATION_UNIT: {
      const retranslations = state.retranslations;

      retranslations.forEach((x) => {
        if (x.id === action.data.retranslationHostId) {

          const some = x.companies.some((c) => {
            return c.id === action.companyId;
          });

          if (!some) x.companies.push({ id: action.companyId });

          x.companies.forEach((c) => {
            if (c.id === action.companyId) {
              c.units.push({
                id: action.data.unitId,
                title: "",
              });
            }
          });
        }
      });

      return Object.assign({}, state, {
        createRetranslationUnitTypesDataState: queriesStates.READY,
        retranslations: retranslations,
      });
    }
    case REQUEST_CREATE_RETRANSLATION_UNIT_FAILURE: {
      return Object.assign({}, state, {
        createRetranslationUnitTypesDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_DELETE_RETRANSLATION_UNIT: {
      return Object.assign({}, state, {
        deleteRetranslationUnitTypesDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_DELETE_RETRANSLATION_UNIT: {
      const retranslations = state.retranslations;

      retranslations.forEach((x) => {
        if (x.id === action.data.retranslationHostId) {
          x.companies.forEach((c) => {
            if (c.id === action.companyId) {
              c.units = c.units.filter((y) => {
                return y.id !== action.data.unitId;
              });
            }
          });
        }
      });

      return Object.assign({}, state, {
        deleteRetranslationUnitTypesDataState: queriesStates.READY,
        retranslations: retranslations,
      });
    }
    case REQUEST_DELETE_RETRANSLATION_UNIT_FAILURE: {
      return Object.assign({}, state, {
        deleteRetranslationUnitTypesDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    default:
      return state;
  }
};

export default retranslationsReducer;
